// orderColumns.js
import { Flex, Text } from "@chakra-ui/react";
import StatusBadge from "components/badge/StatusBadge";
import { formatTime } from "constants/commonFunctions";
import { formatDateToDDMONTHNAMEYYYY } from "utils/common";

export const orderColumns = [
  {
    Header: "Order ID",
    accessor: "order_id",
    Cell: ({ value }) => {
      return (
        <a
          href={`/#/admin/subscriptions/?order_id=${value}`}
          target="_blank"
          rel="noreferrer"
          cursor="pointer"
          whiteSpace={"nowrap"}
          style={{ fontSize: "11px", fontWeight: 600, cursor: "pointer" }}
        >
          {value}
        </a>
      );
    },
  },
  {
    Header: "User Name",
    accessor: "user_data.first_name",
    Cell: ({ value, row }) => (
      <Text>
        {value} {row?.original?.user_data?.last_name}{" "}
        {row.original?.user_data?.role ?? "-"}
      </Text>
    ),
  },
  {
    Header: "Phone Number",
    accessor: "user_data.phone",
  },
  {
    Header: "Plan Name",
    accessor: "plan_data.name",
    Cell: ({ value, row }) => (
      <Text>
        {value} {row?.original?.plan_data?.type ?? "-"}
      </Text>
    ),
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => (
      <Flex align="center" justify={"center"}>
        <Text>
          <StatusBadge status={value} />
        </Text>
      </Flex>
    ),
  },
  {
    Header: "CREATED BY",
    accessor: "admin_data",
    Cell: ({ value, row }) => {
      const adminName = `${value?.first_name} ${value?.last_name}`;
      const created_by = row?.original?.created_by || "user";
      const label = `${created_by}${
        value?.first_name ? ` (${adminName})` : ""
      }`;

      return (
        <Flex align="center" justify={"center"}>
          <Text>{label || "-"}</Text>
        </Flex>
      );
    },
  },
  {
    Header: "Created At",
    accessor: "created_at",
    Cell: ({ value }) => (
      <Text>
        {formatDateToDDMONTHNAMEYYYY(value)} {formatTime(value)}
      </Text>
    ),
  },
  {
    Header: "IP ADDRESS",
    accessor: "created_ip",
    Cell: ({ value }) =>
      value ? (
        <a
          href={`https://whatismyipaddress.com/ip/${value}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: "#3182ce", textDecoration: "underline" }}
        >
          {value}
        </a>
      ) : (
        <Text>-</Text>
      ),
  },
];
